import { useTranslation } from "react-i18next";
import { FunctionComponent } from "react";
import "./login.scss";
import CustomCarousel from "../../components/carousel/Carousel";
import LoginPage from "./components/login-page/LoginPage";

const Login: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="login">
      <div className="left">
        <CustomCarousel />
      </div>
      <div className="login-container">
        <div className="checkbox-and-button">
          <LoginPage />
          <div className="copyright-2024-b">
            {t("auth.copyright", "Copyright ©2024 BỘ GIÁO DỤC VÀ ĐÀO TẠO")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
